/**
 * Styled Components - Created by gustavomedina on 08/03/18.
 */
import styled from 'styled-components'
import Button from 'antd/lib/button'
import col from 'antd/lib/col'
import Row from 'antd/lib/row'
import { GRAY_LIGHTEST, GRAY_DARK, RED, WHITE } from '../../theme/colors'

interface DivProps {
  secondary?: Boolean
}

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  @media (max-width: 1208px) {
    flex-flow: column;
    align-items: center;
  }
`

export const ContainerColumn = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
`

export const TextContent = styled.div`
  margin-top: 20px;
  font-size: 16px;
  margin-bottom: 6px;
`

export const Col = styled(col)`
  @media (max-width: 628px) {
    text-align: center;
    width: 100%;

    .ant-radio-group {
      display: flex;
      justify-content: center;
      margin-top: 15px;
    }

    .ant-radio-group > label {
      align-items: center;
      display: flex;
      height: 50px;
    }
  }
`
export const StyledLabel = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  height: 10%;
  line-height: 22px;
  margin-bottom: 10px;
  width: 25%;
`
export const StyledLoginButton = styled(Button)`
  background-color: ${WHITE};
  border-color: ${RED};
  border-radius: 0px;
  height: 50px;
  width: 20%;
`
export const StyledRow = styled(Row)`
  display: flex;
  margin-top: 10px;
  justify-content: center;
`

export const LeftSide = styled.div`
  flex: 1;
  width: 100%;
`

export const RightSide = styled.div`
  flex: 1;
  width: 100%;
`

export const RadioDiv = styled.div`
  margin-right: 28px;
  margin-bottom: 18px;
`

export const ReverseDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  @media (max-width: 628px) {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column-reverse;
    align-items: center;
  }
`
export const TitleLabel = styled.div`
  color: ${GRAY_DARK};
  font-size: 20px;
  font-weight: bold;
  height: 27px;
  line-height: 27px;
  margin-top: 20px;
  width: 145px;

  @media (max-width: 628px) {
    display: flex;
    justify-content: center;
    width: 100%;
  }
`

export const TitleLabel2 = styled.div`
  color: ${GRAY_DARK};
  font-size: 20px;
  font-weight: bold;
  margin-top: 2px;
`

export const SizingTable = styled.div`
  width: 100%;
  ${({ secondary }: DivProps) => secondary ? `
    .sizeHeader, .sizeCell {
      max-width: 50px !important;
    }
    @media (max-width: 698px) {
      .containerSize {
        flex-flow: column-reverse !important;
        align-items: center !important;
      }
    }
  ` : ''}
`
export const radioGroupStyle = {
  marginTop: '10px'
}
export const ImageContainer = styled.div`
  background-color: ${GRAY_LIGHTEST};
  cursor: pointer;
  margin-top: 18px;
  position: relative;
  text-align: center;
  user-select: none;
  width: 100%;
`
export const ImageStyle = {
  height: '100%',
  width: '100%'
}
export const StyledFooterLabel = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  height: 30%;
  line-height: 22px;
  margin-bottom: 10px;
  margin-top: 21px;
  width: 100%;
`

export const SubLabel = styled.div`
  font-size: 14px;
  display: inline-block;
  font-weight: normal;
  margin-left: 12px;
  color: darkgray;
`

export const SizeDescription = styled.div`
  margin-top: 10px;
  margin-bottom: 12px;
  color: #868686;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/FitInfo/styledComponents.tsx